type TrackProps = Record<string, unknown> | undefined;

function trackEventLazy(name: string, properties?: TrackProps) {
  if (typeof window === "undefined") return;
  void import("@/lib/analytics-events").then(({ trackEvent }) => trackEvent(name, properties));
}

export function trackCalculatorUsed(props: {
  calculator: string;
  language?: string;
  [key: string]: unknown;
}) {
  trackEventLazy("calculator_used", props);
  trackFreeToolCompleted({
    tool_name: props.calculator,
    language: props.language,
    source_path: typeof props.source_path === "string" ? props.source_path : undefined,
  });
}

export function trackMatchingCompleted(props: { score: number; language?: string }) {
  trackEventLazy("matching_completed", props);
}

export function trackFreeToolStarted(props: {
  tool_name: string;
  source_path?: string;
  language?: string;
  placement?: string;
  step?: string;
}) {
  trackEventLazy("free_tool_started", props);
}

export function trackFreeToolCompleted(props: {
  tool_name: string;
  source_path?: string;
  language?: string;
  placement?: string;
  step?: string;
  has_time?: boolean;
}) {
  trackEventLazy("free_tool_completed", props);
}
